import { render, staticRenderFns } from "./ListFolder.vue?vue&type=template&id=5170578a&scoped=true&lang=pug&"
import script from "./ListFolder.vue?vue&type=script&lang=js&"
export * from "./ListFolder.vue?vue&type=script&lang=js&"
import style0 from "./ListFolder.vue?vue&type=style&index=0&id=5170578a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5170578a",
  null
  
)

export default component.exports